import styled from 'styled-components';

export const NoSelect = styled.span`
  user-select: none;
`;
